import { stringify } from 'utils/json'

// The first array returned for each list of categories, so callers get the
// same reference for the same content
const seen = new Map<string, string[]>()

type Categorised = { category?: string } | null | undefined

export const getCategories = (
  items: Record<string, Categorised> | Categorised[] | null | undefined,
) => {
  const categories = Object.values(items ?? {})
    .map(item => item?.category)
    .filter((category): category is string => Boolean(category))
    .sort((a, b) => (a < b ? -1 : b < a ? 1 : 0))
  const unique = [...new Set(categories)]
  const key = stringify(unique)
  const first = seen.get(key)
  if (first) return first
  seen.set(key, unique)
  return unique
}

/**
 * The competencies a job profile asks the report to present, or null when it
 * makes no such request.
 *
 * This is independent of the competencies selected for scoring: a score is
 * calculated for every competency regardless of the selection, so a profile may
 * name any of them. Callers fall back to the selected ones themselves, since
 * they differ in how they order the result.
 */
export const getDisplayCompetencies = (profile: {
  displayCompetencies?: string[]
}): string[] | null => {
  const shown = profile?.displayCompetencies

  return shown == null || shown.length === 0 ? null : shown
}
